/**
 * Backend agora pode estar em origem diferente do frontend (Cloudflare Pages
 * separado do backend em Docker/EC2, ver Fase 3 do roadmap de dockerizacao).
 * VITE_API_URL vazio mantem os caminhos relativos (dev local, mesma origem).
 */
const API_BASE_URL = (import.meta.env.VITE_API_URL ?? "").replace(/\/$/, "");

export function apiUrl(path: string): string {
  return `${API_BASE_URL}${path}`;
}
